export enum CONFIRM_RESULT {
  OK,
  CANCEL,
  DISMISS,
  NOOP,
}

export interface ConfirmOptions {
  title: {
    text: string;
    payload?: Record<string, any>;
  };
  message: {
    text: string;
    payload?: Record<string, any>;
  };
}
